export default __webpack_public_path__ + "static/hram-ikony-bozhiej-materi-sporitelnica-hlebov-krovlya_2-6908373a348f6203a85802b102659f8e.jpg";